import api from "./axios";
import { API_ENDPOINTS } from "../constants";
import { logError } from "../common/utils/logger";

export const getContext = async (structureName, webContentName) => {
  try {
    const response = await api.get(API_ENDPOINTS.GET_CONTEXT, {
      params: {
        structureName,
        webContentName,
      },
    });

    return response?.data ?? null;
  } catch (error) {
    logError("Get context failed", error);
    throw error;
  }
};
